import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'tw-elements-react/dist/css/tw-elements-react.min.css';
import { WagmiConfig } from 'wagmi';
import { client } from 'contexts/PolygonWalletContext';
import { SmartWalletProvider } from 'contexts/SmartWalletContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <WagmiConfig client={client}>
    <SmartWalletProvider>
      <App />
    </SmartWalletProvider>
  </WagmiConfig>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
